var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "700dacbd60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 75 L 168 75 L 168 309 L 27 309 Z M 27 75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6eea1cc0a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.226562 83.03125 L 341.519531 61.621094 L 356.78125 292.117188 L 33.492188 313.527344 Z M 18.226562 83.03125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aabf4fbfde"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.226562 83.03125 L 341.519531 61.621094 L 356.78125 292.117188 L 33.492188 313.527344 Z M 18.226562 83.03125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3d8385e59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.238281 83.207031 L 156.609375 74.046875 L 171.851562 304.230469 L 33.480469 313.390625 Z M 18.238281 83.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0ab39e85a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.238281 83.207031 L 156.609375 74.046875 L 171.835938 304.007812 L 33.46875 313.171875 Z M 18.238281 83.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a0b387e414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 212 63 L 353 63 L 353 297 L 212 297 Z M 212 63 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7455b1a97e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.226562 83.03125 L 341.519531 61.621094 L 356.78125 292.117188 L 33.492188 313.527344 Z M 18.226562 83.03125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c9e4665241"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.226562 83.03125 L 341.519531 61.621094 L 356.78125 292.117188 L 33.492188 313.527344 Z M 18.226562 83.03125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4e254369b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 203.160156 70.960938 L 341.53125 61.800781 L 356.773438 291.984375 L 218.40625 301.144531 Z M 203.160156 70.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67e5d7e1a3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 203.160156 70.960938 L 341.53125 61.800781 L 356.757812 291.761719 L 218.390625 300.925781 Z M 203.160156 70.960938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#700dacbd60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6eea1cc0a0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aabf4fbfde)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e3d8385e59)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0ab39e85a8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efeeef",
    d: "M 94.058594 171.558594 C 85.945312 172.09375 78.296875 174.09375 71.242188 177.171875 C 71.390625 169.800781 72.234375 162.328125 73.828125 154.878906 C 77.058594 139.550781 83.765625 124.578125 93.207031 110.972656 C 102.679688 97.386719 115.121094 85.261719 129.910156 75.8125 C 113.09375 80.726562 96.8125 89.15625 82.414062 100.722656 C 68.054688 112.296875 55.375 126.902344 46.128906 143.984375 C 36.824219 161.015625 30.628906 180.332031 28.417969 200.613281 C 26.699219 216.726562 27.378906 233.351562 30.703125 249.796875 C 31.316406 254.117188 32.34375 258.289062 33.71875 262.296875 C 33.738281 262.359375 33.753906 262.429688 33.769531 262.492188 L 33.78125 262.488281 C 43.65625 290.984375 71.613281 310.644531 103.128906 308.558594 C 140.902344 306.058594 169.597656 273.292969 167.09375 235.519531 C 164.59375 197.75 131.828125 169.054688 94.058594 171.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a0b387e414)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7455b1a97e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c9e4665241)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4e254369b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67e5d7e1a3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efeeef",
    d: "M 279.183594 159.296875 C 271.078125 159.835938 263.425781 161.835938 256.371094 164.914062 C 256.519531 157.539062 257.363281 150.066406 258.960938 142.617188 C 262.1875 127.292969 268.890625 112.320312 278.335938 98.714844 C 287.808594 85.125 300.246094 73 315.035156 63.550781 C 298.21875 68.46875 281.9375 76.898438 267.539062 88.464844 C 253.183594 100.035156 240.503906 114.644531 231.253906 131.726562 C 221.953125 148.753906 215.757812 168.074219 213.546875 188.351562 C 211.828125 204.472656 212.511719 221.097656 215.832031 237.542969 C 216.449219 241.859375 217.472656 246.023438 218.84375 250.023438 C 218.863281 250.09375 218.878906 250.164062 218.898438 250.234375 L 218.910156 250.226562 C 228.789062 278.722656 256.742188 298.386719 288.257812 296.300781 C 326.03125 293.796875 354.722656 261.03125 352.222656 223.261719 C 349.722656 185.492188 316.957031 156.796875 279.183594 159.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeech);
export default __webpack_public_path__ + "static/media/speech.0a6d84f44efa43ca2d45043bffe59c9c.svg";
export { ForwardRef as ReactComponent };